import { BackofficeSignInMethod, UserType } from '@backoffice-frontend/graphql'
import type { BackofficeUserFormDataFragment } from './graphql/BackofficeUserFormData.hook'

export type BackofficeUserFormValues = {
  user: Omit<BackofficeUserFormDataFragment, 'organizationId'>
  notes: string
  signInMethod: BackofficeSignInMethod
  organizationId: string
}

export const defaultValues: BackofficeUserFormValues = {
  user: {
    operatorTenants: [],
    customerTenants: [],
    ridepoolingServiceTenants: [],
    fleets: [],
    email: '',
    username: '',
    systemUser: false,
    groupsApprover: [],
    timedGroups: [],
    timedServiceAreas: [],
    firstName: '',
    lastName: '',
    userType: UserType.Standard,
  },
  signInMethod: BackofficeSignInMethod.ExternalSso,
  notes: '',
  organizationId: '',
}
